module.exports = __webpack_public_path__ + "img/Dai-re2.7de8b5c1.png";